import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ChatMessage {
  id: number;
  role: 'user' | 'assistant';
  content: string;
  interactionId?: number;
  feedback?: 1 | -1;
}

interface ChatState {
  isOpen: boolean;
  isExpanded: boolean;
  messages: ChatMessage[];
  isLoading: boolean;
  nextMessageId: number;
  toggleOpen: () => void;
  toggleExpanded: () => void;
  addMessage: (msg: Omit<ChatMessage, 'id'>) => void;
  setLoading: (loading: boolean) => void;
  clearMessages: () => void;
  setFeedback: (interactionId: number, feedback: 1 | -1) => void;
}

export const useChatStore = create<ChatState>()(
  persist(
    (set) => ({
      isOpen: false,
      isExpanded: true,
      messages: [],
      isLoading: false,
      nextMessageId: 1,
      toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),
      toggleExpanded: () => set((state) => ({ isExpanded: !state.isExpanded })),
      addMessage: (msg) =>
        set((state) => ({
          messages: [...state.messages, { ...msg, id: state.nextMessageId }],
          nextMessageId: state.nextMessageId + 1,
        })),
      setLoading: (loading) => set({ isLoading: loading }),
      clearMessages: () => set({ messages: [] }),
      setFeedback: (interactionId, feedback) =>
        set((state) => ({
          messages: state.messages.map((msg) =>
            msg.interactionId === interactionId ? { ...msg, feedback } : msg
          ),
        })),
    }),
    {
      name: 'aspen-chat',
      partialize: (state) => ({
        messages: state.messages,
        nextMessageId: state.nextMessageId,
      }),
    }
  )
);
